var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMobileTransacitonIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.05312 11.5H0.000488281V0.5H1.05312V11.5ZM6.84259 10.95H1.57944V9.3H6.84259V10.95ZM8.42154 8.2H1.57944V6.55H8.42154V8.2ZM10.0005 5.45H1.57944V3.8H10.0005V5.45ZM5.78996 2.7H1.57944V1.05H5.78996V2.7Z",
    fill: "#D2DAE4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMobileTransacitonIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile-transaciton-icon.6cab3146c5be47026559c30601cde6b5.svg";